/**
 * @GENERATED from Figma node 693:15887
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const AtriumHqBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#DE722E"
      fillRule="evenodd"
      d="M3.667 2C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="M16.583 4.5c-.69 0-1.25.56-1.25 1.25v12.5a1.25 1.25 0 0 0 2.5 0V5.75c0-.69-.56-1.25-1.25-1.25M11.167 9.083a1.25 1.25 0 1 1 2.5 0v9.167a1.25 1.25 0 0 1-2.5 0zM8.25 10.333c-.69 0-1.25.56-1.25 1.25v6.667a1.25 1.25 0 1 0 2.5 0v-6.667c0-.69-.56-1.25-1.25-1.25"
    />
  </svg>
);
const ForwardRef = React.forwardRef(AtriumHqBright);
export { ForwardRef as AtriumHqBright };
